import { defineComponent as _defineComponent } from 'vue'
import { getSupportedLocales } from '@/utils/supported-locales';
import { Locale, useI18n } from 'vue-i18n';
import CountryFlag from 'vue-country-flag-next'; // https://www.npmjs.com/package/vue-country-flag-next
import { reactive, ref } from 'vue';
import { changeTitle } from '@/utils/title-changer';


export default /*#__PURE__*/_defineComponent({
  __name: 'LangSwitch',
  setup(__props, { expose: __expose }) {
  __expose();

const locales = reactive(getSupportedLocales());
const dropdown = ref(false);
const i18n = useI18n();

const setLocale = (locale: Locale) => {
  i18n.locale.value = locale;
  changeTitle();
};

const toggleDropdown = () => {
  dropdown.value = !dropdown.value;
};

const closeDropdown = () => {
  dropdown.value = false;
};


const __returned__ = { locales, dropdown, i18n, setLocale, toggleDropdown, closeDropdown, get CountryFlag() { return CountryFlag } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})